import React from 'react';
import { is } from '../../../services';
import clsx from 'clsx';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Dropdown Divider Component
 * @param className {string} Additionnal CSS Classes
 */
const DropdownDivider = ({ className, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('dropdown-divider', is('divider'), className));
    return React.createElement("hr", { className: classes, ...others });
};
export default DropdownDivider;
//# sourceMappingURL=DropdownDivider.js.map